import MultipleCurrencyAdjustAmount from './MultipleCurrencyAdjustAmount';

export default MultipleCurrencyAdjustAmount;
